import {
  type BrandSliderConfig,
  getBrandSlidersForBlockchain,
  launchedCollectionToBrandSlider,
  mergeBrandSliders,
} from "@/app/components/brands/brand-slider-config"
import type { SpotlightDrop } from "@/app/page-main.reatom"
import type { LaunchedCollectionPublic } from "@anaconda/core/collection-launcher/types"

/** A homepage carousel slide before it is drawn. */
export type CarouselSlide =
  | { type: "brand"; slider: BrandSliderConfig }
  | { type: "drop"; drop: SpotlightDrop }

/**
 * A page's slides in default order: its launched collections, newest first,
 * then the configured brand slides, then the spotlight drops. The homepage
 * and the launcher's admin page both list them from here.
 */
export function getDefaultCarouselSlides(
  blockchain: string,
  launches: readonly LaunchedCollectionPublic[],
  drops: readonly SpotlightDrop[],
): CarouselSlide[] {
  return [
    ...mergeBrandSliders(
      launches.map(launchedCollectionToBrandSlider),
      getBrandSlidersForBlockchain(blockchain),
    ).map((slider) => ({ type: "brand" as const, slider })),
    ...drops.map((drop) => ({ type: "drop" as const, drop })),
  ]
}

/** What the homepage layout knows a slide by (`@anaconda/core/homepage-layout`). */
export function getCarouselSlideKey(slide: CarouselSlide): string {
  if (slide.type === "drop") return `drop:${slide.drop.id}`
  return slide.slider.collectionId
    ? `launch:${slide.slider.collectionId}`
    : `brand:${slide.slider.slug}`
}
